import EventGuidelineEdit from './EventGuidelineEdit';

export default EventGuidelineEdit;
